export default class Router {
    constructor(routes) {
        this.routes = routes;
    }

    load() {
        this.routes.forEach(route => {
            if (route.resolve) {
                if (document.querySelector(route.resolve)) {
                    this.run(route.module);
                }
            } else {
                this.run(route.module);
            }
        });
    }

    async run(importFn) {
        const { default: init } = await importFn();
        init();
    }
}